import React from "react";
import { useForm } from "react-hook-form";
import { Button } from "./ui/button";
import { HookInput } from "../helpers/formHelpers";

const SignupForm = ({ onSubmit }: { onSubmit: any }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  return (
    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
      <HookInput
        control={control}
        name="email"
        label="Email Address"
        errors={errors}
        rules={{ required: "Required" }}
      />
      <HookInput
        control={control}
        name="password"
        type="password"
        label="Password"
        errors={errors}
        rules={{ required: "Required" }}
      />
      <ul>
        <li>Your password can't be too similar to your other personal information.</li>
        <li>Your password must contain at least 8 characters</li>
        <li>Your password can't be a commonly used password</li>
        <li>Your password can't be entirely numeric</li>
      </ul>
      <HookInput
        control={control}
        name="password2"
        type="password"
        label="Password confirmation"
        errors={errors}
        rules={{
          required: "Required",
          validate: (value) => value === getValues("password") || "Passwords must match",
        }}
      />
      <Button type="submit">Sign Up</Button>
    </form>
  );
};

export default SignupForm;
